import type { ReactElement } from 'react'

import type { InputProps } from './inputWrapper/InputWrapper'

type Props<Label extends string | ReactElement> = InputProps<Label> & {
  id?: string
}

export const createInternalWrapperPropsAndId = <
  Label extends string | ReactElement = string,
>({
  wrapperProps,
  id = crypto.randomUUID(),
}: Props<Label>) => ({
  internalWrapperProps: { ...wrapperProps, htmlFor: id },
  id,
  labelId: createLabelIdFromLabel({ label: wrapperProps.label, id }),
})

export const createLabelIdFromLabel = ({
  label,
  id,
}: {
  label?: string | ReactElement // Portals-apg use this in a couple of places
  id?: string
}) => (label && id ? `${id}-label` : undefined)
